import { render, staticRenderFns } from "./MasterReview.vue?vue&type=template&id=36289316&"
import script from "./MasterReview.vue?vue&type=script&lang=js&"
export * from "./MasterReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports